<template>
  <el-container class="container" style="padding:0">
    <!-- 侧边栏 -->
    <el-aside width="200px" style="background: rgb(246, 248, 251);height:100%">
      <LeftBar :left-items="leftItems" :currentSelectLeftItemKey="currentSelectLeftItemKey" @selectChange="leftItemselectChange"/>
    </el-aside>
    <!-- 主要内容容器 -->
    <el-container v-show="currentPage=='main'" style="position:relative;height:100%;background: #f0f2f5;">
      <div style="height: calc(100vh - 86px);width:100%;box-sizing: border-box;padding:20px;overflow: scroll;">
        <BusinessMain :refreshCount="refreshCount" :resizeChartCount="resizeChartCount" @editClick="editClick" @addBussiness="addBussiness" @ranking="currentPage='clueRanking';currentSelectLeftItemKey='clueRanking'"/>
      </div>
      <addBusinessDialog v-model="dialogFormVisible" @refresh="refreshCount++"></addBusinessDialog>
    </el-container>
    <el-container v-if="currentPage=='clueDetail' && selectClueInfo" style="position:relative;height:100%;background: #f0f2f5;display: flex; flex-direction: column;">
      <!-- 容器顶部筛选条件按钮 -->
      <el-header style="height: 60px;display: flex;align-items: center;">
        <el-button @click="currentPage='main';currentSelectLeftItemKey='main'" style="margin-right:10px;padding:6px 10px;" size="mini">返回</el-button>
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item><span class="hover-link" @click="currentPage='main'">{{leftItems.find(i=>i.key==currentSelectLeftItemKey).name}}</span></el-breadcrumb-item>
          <el-breadcrumb-item>{{pages.find(p=>p.key==currentPage).name}}</el-breadcrumb-item>
        </el-breadcrumb>
      </el-header>
      <div style="height: 100%;width:100%;box-sizing: border-box;padding:20px;overflow: scroll;">
        <BusinessDetail :clue_id="selectClueInfo.id" @refresh="refreshCount++"></BusinessDetail>
      </div>
    </el-container>
    <el-container v-if="currentPage=='clueRanking'" style="position:relative;height:100%;background: #f0f2f5;display: flex; flex-direction: column;">
      <!-- 容器顶部筛选条件按钮 -->
      <el-header style="height: 60px;display: flex;align-items: center;margin-left:10px;">
        <el-button @click="currentPage='main';currentSelectLeftItemKey='main'" style="margin-right:10px;padding:6px 10px;" size="mini">返回</el-button>
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item><span class="hover-link" @click="currentPage='main';currentSelectLeftItemKey='main'">{{leftItems.find(i=>i.key==currentSelectLeftItemKey).name}}</span></el-breadcrumb-item>
          <el-breadcrumb-item>{{pages.find(p=>p.key==currentPage).name}}</el-breadcrumb-item>
        </el-breadcrumb>
      </el-header>
      <div style="height: 100%;width:100%;box-sizing: border-box;padding:20px;overflow: scroll;">
        <BusinessRankingBI/>
      </div>
    </el-container>
  </el-container>
</template>

<script>
import CustomTable from "@/component/CustomTable";
import CustomTool from "@/component/Performance/topTool/CustomTool";
import CustomCard from "@/component/Performance/CustomCard";
import CustomDialog from "@/component/PrePayManage/dialog/CustomDialog";
import addBusinessDialog from "@/component/Business/dialog/addBusinessDialog";
import LeftBar from "@/component/Bar/leftBar/LeftBar";
import BusinessDetail from "@/component/Business/detail/BusinessDetail";
import BusinessMain from "@/component/Business/main/BusinessMain";
import BusinessRankingBI from "@/component/Business/ranking/BusinessRankingBI";
import {
  exportAdvance,
  getUnusualList, getAdvance
} from '../../api/api'
import {getMonthStartDate} from "@/utils/util";
export default {
  name: "Business",
  props:["refreshId"],
  components:{
    CustomTable,
    CustomTool,
    CustomCard,
    CustomDialog,
    addBusinessDialog,
    LeftBar,
    BusinessDetail,
    BusinessMain,
    BusinessRankingBI
  },
  data(){
    return {
      column_mapper:{
        "advance_name":"预付款名称:like",
        "stat_time":"结算日期:date",
        "client_name": "客户:varchar"
      },

      currentPage:"main",
      selectClueInfo:null,
      pages:[
        {
          id: 0,
          name: "商机详情页",
          key: "clueDetail"
        },
        {
          id: 1,
          name: "统计与排行",
          key: "clueRanking"
        }
      ],

      tableData:{
        //表格列表相关
        detailLoading: false,
        projectList: [],//表格列表所有数据
        showProjectList:[],//显示的数据
        column_mapper: {},//表头所有列的枚举
        showColoums: [],//当前显示的表头列
        sortColumnName: "",//需要排序的列名
        sortColumnOrder: "",//排序的命令
        totalnums: 10,//所有的数据条数
        pageNumber: 1,//当前页
        fixedList: ['project:project_id', 'project:project_name'],
        pagesize: 10,//一页数据的行数（公用）
        pagination:true,
        tableColumnCustomConfig:{//图表某些列定制化显示
          'project:project_id':{
            type:"popover",
            showRule:{
              key:"project:project_remark",
              value:"异常"
            },
            project_id:"",
            closeTime:1,
            openTime:0,
            forceClose:false,
            show:false,
            popoverDatas:[]
          }
        }
      },
      leftItems: [
        {
          id: 0,
          name: "商机线索池",
          key: "main"
        },
        {
          id: 1,
          name: "统计与排行",
          key: "clueRanking"
        }
      ],
      currentSelectLeftItemKey:"main",


      dialogFormVisible:false,
      refreshCount:0,
      resizeChartCount:0,
      filterRequestData:{},
      dialogRequestData:{
        invoice_id:""
      },
      filterContent:{
        queryCond: [],
        sortCond: {
          columnName: "",
          value: ""
        },
      },
      filterArchiveData:{
        start_end_date_dynamic:[],
        queryCond: []
      },

      showTimeArea:true
    }
  },
  async mounted() {
    window.vm4 = this
    this.$bus.$on("cludInfo", (clueInfo)=>{
      console.log("cccclueinfo")
      this.currentPage = "clueDetail"
      this.selectClueInfo = clueInfo
    })
  },

  watch:{
    currentPage(newVal){
      if(newVal=='main'){
        this.resizeChartCount++
      }
    },
    refreshId(newVal){
      // console.log('refreshId change,刷新todoList',newVal)
      this.refreshCount++
    },
  },

  methods:{
    /**
     * 添加商机
     */
    addBussiness(){
      this.dialogFormVisible = true
    },

    editClick(e){
      this.selectClueInfo = e
      this.currentPage = "clueDetail"

    },


    leftItemselectChange(key){
      // console.log('左侧item切换',key)
      this.currentSelectLeftItemKey = key
      this.currentPage = key
    },



  }
}
</script>
<style lang="scss">
.hover-link{
  cursor: pointer;
  color: #303133;
  font-weight:700;
}

.hover-link:hover{
  color:#1473E3;
}

.el-row {
  margin-bottom: 40px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  height:200px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
</style>

